module.exports = __webpack_public_path__ + "img/Group 85.68fafee7.jpg";